module.exports = __webpack_public_path__ + "img/product_41.f86ad9d.webp";